import * as React from "react";
import { QueryClientProvider } from 'react-query';
import { Provider } from "react-redux";
import { HashRouter } from "react-router-dom";
import { CompatRouter } from "react-router-dom-v5-compat";
import * as Sentry from '@sentry/browser';

import { route } from "./routes";
import { configureStore, initStore } from "./store/configStore";


import { DefaultReactQueryClient, SENTRY_DSN } from '../Shared';

if (window.postbuildEnv.RAILS_ENV === 'production') {
  Sentry.init({ dsn: SENTRY_DSN, environment: 'production' })
} else if (window.postbuildEnv.RAILS_ENV === 'staging') {
  Sentry.init({ dsn: SENTRY_DSN, environment: 'staging' })
}

const store = configureStore();
store.dispatch(initStore());
const queryClient = new DefaultReactQueryClient();

class App extends React.Component<{}, {}> {
  componentDidMount() {
    document.title = 'Quill Proofreader'
  }

  public render(): JSX.Element {
    return (
      <Provider store={store}>
        <QueryClientProvider client={queryClient} contextSharing={true}>
          <HashRouter basename="/">
            <CompatRouter>
              {route}
            </CompatRouter>
          </HashRouter>
        </QueryClientProvider>
      </Provider>
    );
  }
}

export default App;
